import { useContext } from 'react'
import { AuthContext } from '../auth-context'

const useAuthContext = () => {
  const authValues = useContext(AuthContext)
  return { ...authValues }
}

export default useAuthContext
